import React from 'react';
import SmartKeyMetricCard, { getCardMetricType } from './SmartKeyMetricCard';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { UseMetricByWeekIdArgs } from 'src/serverProxy/useAtlasV2MetricByWeekId';
import type { UseMetricByWeekIdV2Args } from 'src/components/BeaconV2Components/SplineChartV2/useMetricByWeekIdV2';
import ContentKeyMetricCard from './ContentKeyMetricCard';
import { getAppSubscriptionTier } from 'src/utils/app';
import DorisMetricCards from 'src/components/BeaconV2Components/KeyMetricCards/DorisMetricCards';
import ConversionCard from 'src/components/BeaconV2Components/KeyMetricCards/ConversionCard';

export interface KeyMetricCardDefinition extends UseMetricByWeekIdArgs {
  onClick?: () => void;
  title?: string;
  marketShareBuilder?: UseMetricByWeekIdV2Args['marketShareBuilder'];
}
export interface KeyMetricCardsProps {
  cardDefinitionsByColumn: KeyMetricCardDefinition[][];
}

/**
 * Displays columns of key metric summary cards
 */
const KeyMetricCards = ({ cardDefinitionsByColumn }: KeyMetricCardsProps) => {
  const isBeaconPro = getAppSubscriptionTier() === 'pro';

  return (
    <Flex gap="mdl">
      {cardDefinitionsByColumn.map((cardDefinitions) => (
        <Flex flexDirection="column" key={`column-${cardDefinitions[0].fieldName}`} gap="md">
          {cardDefinitions.map((cardDefinition, index) => {
            const variant = index === 0 ? 'large' : 'small';
            const keyProp = `cell-${cardDefinition.indexName}-${cardDefinition.fieldName}`;

            switch (cardDefinition.indexName) {
              case 'new-content-metrics':
                if (isBeaconPro) {
                  return (
                    <ContentKeyMetricCard
                      variant={variant}
                      key={keyProp}
                      indexName={cardDefinition.indexName}
                      fieldName={cardDefinition.fieldName}
                      title={cardDefinition.title}
                      onClick={cardDefinition.onClick}
                    />
                  );
                }
                return <SmartKeyMetricCard variant={variant} key={keyProp} {...cardDefinition} />;

              case 'trafficV2':
                if (cardDefinition.fieldName === 'purchaseRate') {
                  return (
                    <ConversionCard
                      variant="large"
                      title={cardDefinition.title}
                      indexName={cardDefinition.indexName}
                      fieldName={cardDefinition.fieldName}
                      onClick={cardDefinition.onClick}
                    />
                  );
                }

                return (
                  <DorisMetricCards
                    variant={variant}
                    queryKey={cardDefinition.fieldName}
                    indexName={cardDefinition.indexName}
                    fieldName={cardDefinition.fieldName}
                    apiMetricType={cardDefinition.fieldName}
                    MetricToDisplay={getCardMetricType(cardDefinition.indexName, cardDefinition.fieldName)}
                    key={keyProp}
                    title={cardDefinition.title}
                    onClick={cardDefinition.onClick}
                  />
                );

              default:
                return <SmartKeyMetricCard variant={variant} key={keyProp} {...cardDefinition} />;
            }
          })}
        </Flex>
      ))}
    </Flex>
  );
};

export default KeyMetricCards;
